import * as React from 'react';

function LifeLongCardsIcon() {
  return (
      <img src={"logo512.png"} alt="Logo" style={{ maxWidth: '30px'}} />
  );
}
export default LifeLongCardsIcon;